// removed by extract-text-webpack-plugin
module.exports = {"popover":"antd-pro-notice-icon-popover","noticeButton":"antd-pro-notice-icon-noticeButton","icon":"antd-pro-notice-icon-icon","tabs":"antd-pro-notice-icon-tabs"};


//////////////////
// WEBPACK FOOTER
// /Applications/MAMP/htdocs/www/alipay-cd/project/antd-pro/antd-pro/scaffold/src/components/NoticeIcon/index.less
// module id = 631
// module chunks = 0